<template>
  <div>
    <!-- Desktop Navigation -->
    <v-app-bar app class="hidden-md-and-up">
      <!-- Left Section: Logo -->
      <v-toolbar-title @click="$router.push('/Dashboard')">
        <v-img
          src="../../src/assets/images/teamitelogo.webp"
          height="30px"
          width="100px"
          style="cursor: pointer"
        ></v-img>
      </v-toolbar-title>

      <!-- Right Section: Hamburger Menu -->
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <!-- Hamburger Icon -->
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <!-- Dropdown Menu Content -->
        <v-list>
          <!-- Profile Option -->
          <v-list-item>
            <v-list-item-avatar>
              <v-img
                @click="profilePage()"
                v-if="appUser.photo"
                :src="mediaURL + appUser.photo"
                height="40px"
                width="40px"
                style="border-radius: 50%; object-fit: cover"
              ></v-img>
              <v-img
                @click="profilePage()"
                v-else
                src="../assets/images/noProfile.png"
                height="40px"
                width="40px"
                style="border-radius: 50%; object-fit: cover"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title @click="profilePage()">{{
                appUser.name
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Settings Option -->
          <v-list-item @click="$router.push('/Settings')">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>

          <!-- Logout Option -->
          <v-list-item @click="logoutCheck">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-layout
      wrap
      justify-center
      class="hidden-sm-and-down"
      style="height: 80px"
    >
      <v-flex md12 lg12 class="fixItem">
        <v-layout wrap justify-center fill-height>
          <v-flex md10 xs12 lg9 align-self-center>
            <v-card color="transparent" elevation="0">
              <v-layout wrap justify-center>
                <v-flex md5 lg7>
                  <v-layout wrap justify-start>
                    <v-flex md8 lg6 pa-0>
                      <v-layout wrap justify-start>

                        <!-- <v-flex
                          @click="$router.push('/Dashboard')"
                          xs8
                          lg7
                          align-self-center
                        >
                          <v-img
                            class="responsive-img"
                            style="cursor: pointer"
                            src="../../src/assets/images/teamitelogo.webp"
                          ></v-img>
                        </v-flex> -->

                        <v-toolbar-title style="cursor: pointer;" @click="$router.push('/Dashboard')" class="align-center d-flex pl-0">
        <span class="logo-icon">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <v-img
                src="../../src/assets/images/teamitelogo.webp"
                width="150px"
                contain
                height="50px"
                class="mt-2"
              />
            </v-flex>
          </v-layout>
        </span>
      </v-toolbar-title>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex md4 lg3 align-self-center @click="profilePage()">
                  <v-layout wrap justify-end>
                    <v-flex
                      md2
                      lg2
                      style="cursor: pointer"
                      v-if="appUser.photo"
                    >
                      <v-img
                        :src="mediaURL + appUser.photo"
                        height="40px"
                        width="40px"
                        style="border-radius: 50%; object-fit: cover"
                      ></v-img>
                    </v-flex>

                    <v-flex md2 lg2 style="cursor: pointer" v-else>
                      <v-img
                        src="../assets/images/noProfile.png"
                        height="40px"
                        width="40px"
                        style="border-radius: 50%; object-fit: cover"
                      ></v-img>
                    </v-flex>

                    <v-flex
                      md4
                      lg4
                      pl-2
                      align-self-center
                      style="cursor: pointer"
                      class="text-start"
                    >
                      <span style="font-family: Lato-regular">{{
                        getFirstName(appUser.name)
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- <v-flex lg1 align-self-center>
                  <v-icon>mdi-bell</v-icon>
                </v-flex> -->

                <v-flex md1 lg1 class="text-end" align-self-center>
                  <v-btn @click="$router.push('/Settings')" plain class="px-0">
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex md2 lg1 class="text-end" align-self-center>
                  <v-btn @click="logoutCheck()" plain class="px-0">
                    <span
                      style="
                        font-family: Lato-Regular;
                        font-size: 15px;
                        font-weight: 600;
                        text-transform: none;
                      "
                    >
                      Logout &nbsp;
                    </span>
                    <v-icon>mdi-logout</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog width="400px" v-model="logoutDialog">
      <v-card>
        <v-layout wrap justify-center>
          <v-flex lg12 pa-4>
            <v-layout wrap justify-center>
              <v-flex lg12 class="text-center">
                <span>Are you sure you want to Log Out?</span>
              </v-flex>
              <v-flex lg12 class="text-center" pt-4>
                <v-layout wrap justify-center>
                  <v-flex lg6>
                    <v-btn @click="logoutDialog = false">
                      <span style="color: #00a08e">Cancel</span>
                    </v-btn>
                  </v-flex>
                  <v-flex lg6>
                    <v-btn style="background-color: #00a08e" @click="Logout()">
                      <span style="color: white">Yes</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog
      :width="
        $vuetify.breakpoint.name == 'xs'
          ? '90%'
          : $vuetify.breakpoint.name == 'sm'
          ? '52%'
          : $vuetify.breakpoint.name == 'md'
          ? '40%'
          : $vuetify.breakpoint.name == 'lg'
          ? '28%'
          : '28%'
      "
      v-model="expiryAlertDialog"
    >
      <v-card>
        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md12 lg12 pa-4>
            <v-layout wrap justify-center>
              <v-flex xs12 sm12 md12 lg12 class="text-end">
                <v-btn icon @click="expiryAlertDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 class="text-center">
                <span
                  style="
                    font-family: Lato-Regular;
                    font-size: 26px;
                    font-weight: 600;
                    color: #00a08e;
                  "
                  >Subscription Expiry Alert !</span
                >
              </v-flex>

              <v-flex xs12 sm10 md10 lg10 pt-5 class="text-center">
                <span style="text-align: justify"
                  >Your plan expires in {{ planEndsIn }} days. Upgrade now to
                  maintain uninterrupted access</span
                >
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 class="text-center" pt-6 pb-3>
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-btn style="background-color: #00a08e" @click="Upgrade()">
                      <span style="color: white">Upgrade Now</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profile: "",
      msg: "",
      showSnackBar: false,
      ServerError: false,
      logoutDialog: false,
      planEndsIn: parseInt(localStorage.getItem("planEndsIn"), 10),
      expiryAlertDialog: false,
    };
  },
  computed: {
    appUser() {
      try {
        const userData = this.$store.state.userData;
        if (typeof userData === "string") {
          return JSON.parse(userData);
        } else {
          return userData; // Assuming it's already an object
        }
      } catch (e) {
        console.error("Failed to parse userData:", e);
        return {};
      }
    },
  },
  mounted() {
    // this.getProfileHeader();
    // const isAlertShown = localStorage.getItem('isExpiryAlertShown');
    // if (!isAlertShown) {
    //   // Get the planEndsIn value and show the dialog if necessary
    //   const storedPlanEndsIn = localStorage.getItem('planEndsIn');
    //   this.planEndsIn = storedPlanEndsIn ? parseInt(storedPlanEndsIn, 10) : null;
    //   console.log("Mounted: planEndsIn", this.planEndsIn);
    //   if (this.planEndsIn !== null && this.planEndsIn <= 7) {
    //     this.expiryAlertDialog = true;
    //     console.log("Showing expiry alert dialog for the first time.");
    //     // Set the flag to true after showing the alert
    //     localStorage.setItem('isExpiryAlertShown', 'true');
    //   }
    // } else {
    //   console.log("Expiry alert has already been shown.");
    // }
  },
  methods: {
    profilePage() {
      if (this.$route.path !== "/profile") {
        this.$router.push("/profile");
      }
    },

    // getFirstName(fullName) {
    //   // Split the name and return the first part
    //   return fullName.split(" ")[0];
    // },

    getFirstName(fullName) {
  // Check if fullName is a valid string
  if (typeof fullName !== "string" || !fullName) {
    return ""; // Return an empty string if fullName is invalid
  }
  // Split the name and return the first part
  return fullName.split(" ")[0];
},


    // resetExpiryAlertFlag() {
    //   // Call this method on logout or when you need to reset the flag
    //   localStorage.removeItem('isExpiryAlertShown');
    //   console.log("Expiry alert flag reset.");
    // },

    logoutCheck() {
      this.logoutDialog = true;
    },
    Logout() {
      this.logoutDialog = false;
      this.$store.commit("logoutUser", true);
      // this.resetExpiryAlertFlag();
    },
  },
};
</script>

<style>
.v-main {
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 !important; /* Override padding */
}
</style>

<style>
.v-main {
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Add padding only for medium and smaller screens */
@media (max-width: 960px) {
  .v-main {
    padding: 64px 0px 0px !important;
  }
}
</style>

<style scoped>
.responsive-img {
  height: 30px;
}

@media (min-width: 600px) {
  .responsive-img {
    height: 40px;
  }
}

@media (min-width: 960px) {
  .responsive-img {
    height: 50px;
  }
}

@media (min-width: 1920px) {
  .responsive-img {
    height: 80px; /* Adjust the height for extra-large screens */
    width: 250px; /* Adjust the width for extra-large screens */
  }
}
</style>